// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__12e55","list":"BalanceDue_list__266id","listRow":"BalanceDue_listRow__2FG4b","total":"BalanceDue_total__14VRX"};